import { z } from 'zod';
export const HcpSearchResultModel = z.object({
    hcpIdentifier: z.string(),
    name: z.string(),
    location: z.string().optional(),
    specialty: z.string().optional(),
    email: z.string().optional(),
    phone: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    middleName: z.string().optional(),
    primaryLocation: z.object({
        lat: z.number(),
        lon: z.number(),
    }).nullable().optional(),
    primaryAffiliationName: z.string().optional(),
    usersEmails: z.array(z.string()).optional(),
    recommendedUserEmails: z.array(z.string()).optional(),
    distance: z.number().optional(),
});
